import { connectionDispatcher } from '../actions/actionCreators'
import { wsConnected, wsMessageReceived, wsDisconnected } from '../actions/actions'
import pako from 'pako'

var socket = null
var pingInfo = {}
var offline_interval
var prev_status__onMessage = null
var delay_message__onMessage = false

const onOpen = (ws, store, league, gamecode) => evt => {
    // Tell the store we're connected
    store.dispatch(wsConnected())

    // clear if ping_int
    if (pingInfo.ping_int) {
        clearInterval(pingInfo.ping_int)
    }

    // Start the ping timer
    pingInfo.ping_int = setInterval(() => {
        let now = Math.round(+new Date() / 1000)
        let diff = now - pingInfo.ping
        // If the difference is more than 40 >_>
        if (diff > 40 && socket != null) {
            socket.close()
            store.dispatch(connectionDispatcher(league, gamecode, true))
            clearInterval(pingInfo.ping_int)
        }
    }, 5600)
}

const onClose = (ws, store) => evt => {
    // Tell the store we've disconnected
    store.dispatch(wsDisconnected())
}

const onError = (ws, store, league, gamecode) => evt => {
    // Fall back to Ajax if WebSockets connection fails, if this fails...then :|
    store.dispatch(connectionDispatcher(league, gamecode, true))
}

const onMessage = (ws, store, league, gamecode) => evt => {
    //var msg = JSON.parse(evt.data);

    //Parse the JSON message received on the websocket
    if (evt.data.length > 20) {
        var bmsg = atob(evt.data)
        var msg = JSON.parse(pako.inflate(bmsg, { to: 'string' }))
    } else {
        msg = JSON.parse(evt.data)
    }

    // If Websockets receives a status other than 'In-Progress' switch back to Ajax
    if (!msg.hasOwnProperty('ts') && msg.data.details.status === 'In-Progress') {
        delay_message__onMessage = false
        store.dispatch(wsMessageReceived(msg, league))
    } else if (!msg.hasOwnProperty('ts')) {
        delay_message__onMessage = false

        if (prev_status__onMessage === 'In-Progress' && msg.data.details.status === 'Final') {
            delay_message__onMessage = true
        }

        store.dispatch(connectionDispatcher(league, gamecode, false, delay_message__onMessage))
    } else {
        pingInfo.ping = msg.ts
    }

    prev_status__onMessage =
        msg.data && msg.data.hasOwnProperty('details') && msg.data.details.status
            ? msg.data.details.status
            : null
}

const offlineCheck = (store, league, gamecode) => {
    if (!navigator.onLine) {
        store.dispatch({ type: 'WS_DISCONNECT' })
        store.dispatch(connectionDispatcher(league, gamecode))
    }
}

const wsMiddle = store => next => action => {
    switch (action.type) {
        //The user wants us to connect
        case 'WS_CONNECT':
            //Start a new connection to the server

            if (socket != null) {
                socket.close()
            }

            if (offline_interval !== null) {
                clearInterval(offline_interval)
            }

            socket = new WebSocket(action.url)
            socket.onmessage = onMessage(socket, store, action.league, action.gamecode)
            socket.onclose = onClose(socket, store)
            socket.onopen = onOpen(socket, store, action.league, action.gamecode)

            // Fall-through to initialize Ajax if Websockets fails to connect.
            socket.onerror = onError(socket, store, action.league, action.gamecode)

            // Check to see if the user goes offline
            offline_interval = setInterval(
                () => offlineCheck(store, action.league, action.gamecode),
                5000
            )

            break

        //The user wants us to disconnect
        case 'WS_DISCONNECT':
            if (socket != null) {
                socket.close()
            }
            socket = null
            break

        //This action is irrelevant to us, pass it on to the next middleware
        default:
            return next(action)
    }
}

export default wsMiddle
